import React, { useEffect, useState } from "react";
import { Button, Form, Spin, Modal } from "antd";
import { useDispatch, useSelector } from "react-redux";

import { PAGE_SIZE } from "../../constants";
import { Link } from "react-router-dom";
import { fetchScoreRules, updateScoreRule } from "../../actions/scoreRule";
import ScoreRulesTable from "../Tables/ScoreRules";
import ScoreRuleForm from "../Forms/ScoreRule";
const ScoreRulesPage = () => {
	const [form] = Form.useForm();
	const dispatch = useDispatch();
	const [isModalVisible, setIsModalVisible] = useState(false);
	const [scoreRuleId, setScoreRuleId] = useState(null);
	const [questionId, setQuestionId] = useState(null);
	const [pagination, setPagination] = useState({});
	const [currentPage, setCurrentPage] = useState(1);
	const limit = Number(PAGE_SIZE) || 20;
	const { scoreRules, status, loading } = useSelector(
		(state) => state.fetchScoreRules,
	);

	const { scoreRuleUpdate } = useSelector((state) => state.updateScoreRule);

	const showModal = () => {
		setIsModalVisible(true);
	};

	const handleOk = () => {
		setIsModalVisible(false);
	};

	const handleCancel = () => {
		setIsModalVisible(false);
	};

	const handleEdit = (record) => {
		showModal();
		setScoreRuleId(record.id);
		setQuestionId(record.question_id);
		const newRecord = { ...record };
		const newProductIds = newRecord.product_ids
			? newRecord.product_ids.ids
			: null;
		const productDescription = newRecord.product_ids
			? newRecord.product_ids.description
			: null;
		const productStatus = newRecord.product_ids
			? newRecord.product_ids.status
			: null;
		const productRecommendation = newRecord.product_ids
			? newRecord.product_ids.recommendation
			: null;
		newRecord.product_ids = newProductIds;
		newRecord.product_description = productDescription;
		newRecord.product_status = productStatus;
		newRecord.product_recommendation = productRecommendation;
		form.setFieldsValue(newRecord);
	};

	const handleSubmitForm = (values) => {
		const newValues = { ...values };
		const newProduct = {
			ids: values.product_ids,
			description: values.product_description,
			status: values.product_status,
			recommendation: values.product_recommendation,
		};

		newValues.product_ids = values.product_ids ? newProduct : null;
		delete newValues.product_description;
		delete newValues.product_status;
		delete newValues.product_recommendation;
		dispatch(updateScoreRule(scoreRuleId, newValues));
		handleOk();
	};

	const withAction = (record) => {
		return (
			<span className="action" style={{ display: "flex" }}>
				<Link to={`/score-rules/${record.id}`}>
					<Button type="link" className="btn-table-action-primary">
						Show
					</Button>
				</Link>
				<Button
					type="link"
					className="btn-table-action-primary"
					onClick={() => handleEdit(record)}
				>
					Edit
				</Button>
			</span>
		);
	};

	const handleFilter = (params) => {
		setCurrentPage(params.page);
		const startAt = (params.page - 1) * Number(PAGE_SIZE);
		dispatch(fetchScoreRules({ start: Number(startAt), count: PAGE_SIZE }));
	};

	const handleTableChange = (params) => {
		handleFilter(params);
	};

	useEffect(() => {
		dispatch(fetchScoreRules({ start: 0, count: PAGE_SIZE }));
	}, []);

	useEffect(() => {
		if (scoreRuleUpdate)
			dispatch(fetchScoreRules({ start: 0, count: PAGE_SIZE }));
	}, [scoreRuleUpdate]);

	useEffect(() => {
		if (scoreRules) {
			setPagination({
				showSizeChanger: false,
				current: currentPage,
				pageSize: limit,
				total: scoreRules.total,
				showTotal: (total) => `${total} Items`,
			});
		}
	}, [scoreRules]);

	return (
		<div className="categories-container">
			<div className="page-header">
				<div className="page-header-breadbrumb">
					<ul>
						<li>Survey Scores</li>
					</ul>
				</div>
			</div>
			<div className="page-content">
				{status === "SUCCEEDED" && (
					<Spin spinning={loading}>
						<ScoreRulesTable
							rowKey="id"
							pagination={pagination}
							onChange2={handleTableChange}
							dataSource={scoreRules.data}
							scrollHeight="calc(100vh - 275px)"
							actionWidth={150}
							withAction={withAction}
						/>
					</Spin>
				)}
			</div>
			<Modal
				className="topic-modal"
				visible={isModalVisible}
				onOk={handleOk}
				onCancel={handleCancel}
				footer={null}
			>
				<ScoreRuleForm
					form={form}
					handleSubmitForm={handleSubmitForm}
					handleCancel={handleCancel}
					questionId={questionId}
				/>
			</Modal>
		</div>
	);
};

export default ScoreRulesPage;
